import { axiosInstance } from "../index";
import config from "../config";
import { getHeaders } from './helpers';

const { apiUrl } = config;


export const getDeclaration = async (creationTime) => {
    const result = await axiosInstance
        .get(
            `${apiUrl}/cruddeclaration/go?creationtime=${creationTime}`,
            { headers: getHeaders() }
        );

    return result.data
}

export const listAllDeclarations = async () => {
    const result = await axiosInstance
        .get(
            `${apiUrl}/cruddeclaration/all`,
            { headers: getHeaders() }
        );

    return result.data
};

export const createDeclaration = async (description, declaration) => {
    const result = await axiosInstance
        .post(
            `${apiUrl}/cruddeclaration/go`,
            {
                meta: {
                    description,
                    status: 'incomplete'
                },
                data: {
                    declaration: declaration || {}
                }
            },
            { headers: getHeaders() }
        )

    return result.data

};

export const submitDeclarationUpdate = async (metadata, declaration, isAmendment) => {
    let params = {};

    if (isAmendment) {
        params.amend = 'true';
    };

    const result = await
        axiosInstance.put(
            `${apiUrl}/cruddeclaration/go`,
            {
                meta: { ...metadata, },
                data: { declaration },
            },
            {
                headers: getHeaders(),
                params
            }
        );

    return result.data;
}

export const deleteDeclaration = async (creationTime) => {
    const result = await axiosInstance
        .delete(
            `${apiUrl}/cruddeclaration/go`,
            { data: { meta: { creationTime } }, headers: getHeaders() }
        );

    return result.data;
};

export const submitDeclaration = async (declaration) => {
    const result = await axiosInstance.post(
        `${apiUrl}/declarations/alpha`,
        declaration,
        { headers: getHeaders() }
    );

    return result.data
}

export const cancelDeclaration = async (functionalReferenceID, cancelReason) => {
    const result = await axiosInstance.delete(
        `${apiUrl}/declarations/all?fid=${functionalReferenceID}&reason=${cancelReason}`,
        { headers: getHeaders() }
    )

    return result.data
}